import ComponentName from '@Constant/componentName'

const crowd = [
  {
    component: () => import('../../views/layout/Index.vue'),
    path: '/app.package',
    redirect: {
      name: ComponentName.appPackage.index
    },
    children: [
      {
        component: () => import('../../views/app-package/index.vue'),
        path: 'index',
        name: ComponentName.appPackage.index,
        auth: '*',
        meta: {
          title: '应用包管理'
        }
      }
    ]
  }
]

export default crowd
